import Upsertable from '@/models/Upsertable'
import { useDeliveryStore } from '@/stores/deliveryStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'
import Customer from '@/models/Customer'
import Depot from '@/models/Depot'

export default class Delivery extends Upsertable {
  static store() {
    return useDeliveryStore()
  }

  store() {
    return Delivery.store()
  }

  static find(uuid) {
    const store = Delivery.store();
    return store.collection.find(item => item.uuid === uuid);
  }

  static confirmDelivery(uuid) {
    Delivery.store().confirmDelivery(uuid)
  }

  customer() {
    let customer = Customer.store().find(this.customer_uuid)
    return Object.assign(new Customer(), customer)
  }

  depot() {
    let depot = Depot.store().find(this.depot_uuid)
    return Object.assign(new Depot(), depot)
  }
  
}

useModelName(Delivery, "Delivery")
ModelRegistry.register(Delivery, "Delivery")